<div class="layout animated fadeIn">
  <main class="content" id="scroll-to-top-ref">
    <div class="content__main">
      <router-outlet></router-outlet>
    </div>
  </main>
</div>
<app-footer></app-footer>